import React from 'react';
import { withNamespaces } from 'react-i18next';
import { headerLinks } from 'constants/links';

import Logo from '../Header/Logo';
import './styles.scss';

const SignUpHeader = ({ t, i18n }) => (
  <div className="header-sign-up">
    <div>
      <Logo width={130} height={32} />
    </div>
    <div className="header-sign-up__right">
      {t('components.SignUp.SignUpHeader.AlreadyHave')}
      <a
        rel="noopener nofollow noreferrer"
        target="_blank"
        href={headerLinks(i18n.language).login}
        title="Sign In"
      >
        {t('components.SignUp.SignUpHeader.SignIn')}
      </a>
    </div>
  </div>
);

export default withNamespaces('core')(SignUpHeader);



// WEBPACK FOOTER //
// ../src/components/SignUp/Header.jsx